<hr class="custom-hr" />
<div class="flex flex-col gap-4 mt-4">
  <p-card header="Wymagania techniczne" tabindex="0" role="note">
    <p>
      Zalecamy korzystanie z portalu na najnowszych wersjach przeglądarek:
      <strong>Mozilla Firefox</strong>, <strong>Google Chrome</strong>.
    </p>
    <p>
      W przeglądarce należy włączyć obsługę treści JavaScript, jeżeli została
      wyłączona.
    </p>
  </p-card>
  <p-card>
    <div class="link">
      <button
        (click)="redirectToManualInstruction()"
        class="hover:underline"
        aria-label="Instrukcja użytkownika, otwiera się w nowej karcie"
      >
        Instrukcja użytkownika <i class="pi pi-arrow-right mr-2"></i>
      </button>
    </div>
  </p-card>
  <app-info-message
    [label]="'Uprzejmie informujemy, że z przyczyn niezależnych od Ministerstwa Rodziny, Pracy i Polityki Społecznej wyłączona została możliwość logowania kwalifikowanym podpisem elektronicznym. Prosimy o korzystanie z login.gov.pl.'"
  />
</div>
